import CryptoJS from "crypto-js";

const SECRET_KEY = "YOUR_SECRET_KEY_32_CHARS"; // keep it constant & secret

export const encrypt = (text: string): string => {
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decrypt = (cipher: string): string => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    return ""; // return empty if decryption fails
  }
};
